"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentPaneSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
// Импортируем схемы
const content_filter_block_schema_1 = require("./content-filter-block-schema");
const lesson_schema_1 = require("./lesson-schema");
const find_content_filter_schema_1 = require("./find-content-filter-schema");
const find_teachers_filter_schema_1 = require("./find-teachers-filter-schema");
const find_meetings_filter_schema_1 = require("./find-meetings-filter-schema");
const find_user_services_filter_schema_1 = require("./find-user-services-filter-schema");
const find_meeting_review_filter_schema_1 = require("./find-meeting-review-filter-schema");
const find_collection_filter_schema_1 = require("./find-collection-filter-schema");
const find_school_filter_schema_1 = require("./find-school-filter-schema");
const find_classrooms_filter_schema_1 = require("./find-classrooms-filter-schema");
const find_categories_filter_schema_1 = require("./find-categories-filter-schema");
const pagination_schema_1 = require("./pagination-schema");
const user_schema_1 = require("./user-schema");
const meeting_schema_1 = require("./meeting-schema");
const user_service_schema_1 = require("./user-service-schema");
const meeting_review_schema_1 = require("./meeting-review-schema");
const collection_schema_1 = require("./collection-schema");
const school_schema_1 = require("./school-schema");
const classroom_schema_1 = require("./classroom-schema");
const content_stats_schema_1 = require("./content-stats-schema");
// Схема соответствует интерфейсу IContentPane
exports.contentPaneSchema = zod_1.z.object({
  format: zod_1.z.nativeEnum(lingo2_models_1.EContentPaneFormat),
  order: zod_1.z.number(),
  hidden: zod_1.z.boolean().optional(),
  loaded: zod_1.z.boolean(),
  loading: zod_1.z.boolean().optional(),
  title: zod_1.z.string().optional(),
  subtitle: zod_1.z.string().optional(),
  cols: zod_1.z.number().optional(),
  rows: zod_1.z.number().optional(),
  contentFilter: find_content_filter_schema_1.findContentFilterSchema.optional(),
  content: zod_1.z.array(lesson_schema_1.lessonSchema).optional(),
  filters: zod_1.z.array(content_filter_block_schema_1.contentFilterBlockSchema).optional(),
  userId: zod_1.z.string().optional(),
  user: user_schema_1.userSchema.optional(),
  userFilter: find_teachers_filter_schema_1.findTeachersFilterSchema.optional(),
  users: zod_1.z.array(user_schema_1.userSchema).optional(),
  meetingFilter: find_meetings_filter_schema_1.findMeetingsFilterSchema.optional(),
  meetings: zod_1.z.array(meeting_schema_1.meetingSchema).optional(),
  userServiceFilter: find_user_services_filter_schema_1.findUserServicesFilterSchema.optional(),
  userServices: zod_1.z.array(user_service_schema_1.userServiceSchema).optional(),
  meetingReviewsFiler: find_meeting_review_filter_schema_1.findMeetingReviewFilterSchema.optional(),
  meetingReviews: zod_1.z.array(meeting_review_schema_1.meetingReviewSchema).optional(),
  collectionsFilter: find_collection_filter_schema_1.findCollectionFilterSchema.optional(),
  collections: zod_1.z.array(collection_schema_1.collectionSchema).optional(),
  schoolsFilter: find_school_filter_schema_1.findSchoolFilterSchema.optional(),
  schools: zod_1.z.array(school_schema_1.schoolSchema).optional(),
  classroomsFilter: find_classrooms_filter_schema_1.findClassroomsFilterSchema.optional(),
  classrooms: zod_1.z.array(classroom_schema_1.classroomSchema).optional(),
  pagination: pagination_schema_1.paginationSchema.optional(),
  infinity: zod_1.z.boolean().optional(),
  routerUrlCreate: zod_1.z.string().optional(),
  routerUrlAll: zod_1.z.string().optional(),
  stats: content_stats_schema_1.contentStatsSchema.optional(),
  is_in_bookmark: zod_1.z.boolean().optional(),
  is_my: zod_1.z.boolean().optional(),
  min_amount_to_show: zod_1.z.number().optional(),
  directoriesFilter: find_categories_filter_schema_1.findCategoriesFilterSchema.optional(),
  segments: zod_1.z.array(zod_1.z.nativeEnum(lingo2_models_1.UserSegmentEnum)).optional(),
  segments_inverse: zod_1.z.boolean().optional(),
  teacher_statuses: zod_1.z.array(zod_1.z.nativeEnum(lingo2_models_1.TeacherStatusEnum)).optional(),
  user_service_categories: zod_1.z.array(zod_1.z.number()).optional(),
  user_services_view: zod_1.z.enum(['wide', 'full', 'narrow', 'half']).optional(),
  ignore_page_filters: zod_1.z.boolean().optional(),
  invert_subjects: zod_1.z.boolean().optional(),
  invert_types: zod_1.z.boolean().optional(),
  always_think_as_empty: zod_1.z.boolean().optional(),
  only_available: zod_1.z.boolean().optional(),
  show_sorting: zod_1.z.boolean().optional(),
  payload__content: zod_1.z.array(user_service_schema_1.userServiceSchema.or(lesson_schema_1.lessonSchema)).optional()
}).catchall(zod_1.z.any());
